"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Date Utility functions for shared use internal to oui-components
 **/
var Messages = require("../codegen/Messages");
var moment = require("moment");
var DateType;
(function (DateType) {
    /**
     * Takes a date and displays long format "Wed, 14 Feb 2018 01:43:08 GMT"
     */
    DateType["Full"] = "full";
    /**
     * Takes a date and disoplays relative format - e.g. 5 days left", "10 minutes ago"
     */
    DateType["Relative"] = "relative";
})(DateType = exports.DateType || (exports.DateType = {}));
/**
 * Formatter for dates, takes dates as string or as Date object.
 * @param value
 * @param language
 * @param type
 */
function formatDate(value, locale, type) {
    if (locale === void 0) { locale = "en"; }
    if (type === void 0) { type = DateType.Full; }
    if (!value) {
        return "-";
    }
    try {
        if (type === DateType.Relative) {
            return formatRelativeDate(value, locale);
        }
        else {
            // loom ICO date formatter requires Date type only
            var dateValue = typeof value === "string" ? new Date(value) : value;
            return Messages.Common.fullDate(dateValue);
        }
    }
    catch (err) {
        console.warn(err);
        return Messages.Table.unexpectedValue();
    }
}
exports.formatDate = formatDate;
/**
 * Loom ICU implementation does not implement relative date, use moment for this
 * @param value
 * @param language
 */
function formatRelativeDate(value, locale) {
    if (locale === void 0) { locale = "en"; }
    // moment hack for chinese as even the latest version of moment is not supporting modern language code for chinese
    var localeToUse = locale.indexOf("zh") === 0 ? "zh_cn" : locale;
    var momentDate = moment(value).locale(localeToUse);
    if (momentDate.isValid()) {
        return momentDate.fromNow();
    }
    else {
        return Messages.Table.unexpectedValue();
    }
}
//# sourceMappingURL=dateUtil.js.map